const URL = 'https://api.revenuecat.com/v1/receipts';


export const sendRevenueCatRequest = (subscriptionID, userID) => {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Platform': 'stripe',
            Authorization: 'Bearer rHwrwykweuMTWGnsZxPwwDuxisUNvZwh'
        },
        body: JSON.stringify({
            'fetch_token': subscriptionID,
            'app_user_id': userID.toString()
        })
    };

    fetch(URL, options)
        .then(response => response.json())
        .then(response => response)
        .catch(err => err);

};